import axios from 'axios';

const service = axios.create({
  // baseURL: 'http://192.168.1.105:9233', 
  baseURL: 'https://xbhzhyl.com.cn/api/', //服务器地址
  
});
// 用户登录
export const userlogin = (query) => {
  return service({
    url: '/user/login',
    method: 'post',
    data: query
  });
};
// 获取服务列表
export const getServiceList = (query) => {
  return service({
    url: "/servicepicture/getServicePictureByType",
    method: 'post',
    data: query
  })
}
// 上传图片-通用
export const upLoadService = (query) => {
  return service({
    url: "/user/getPicUrl",
    method: 'post',
    data: query,
    headers: {
      'Content-Type': 'multipart/form-data'
  }
  })
}
// 修改服务项
export const editService = (query) => {
  return service({
    url: "/servicepicture/updServicePictureByType",
    method: 'post',
    data: query
  })
}
// 获取机构列表
export const getOrgansList = (query) => {
  return service({
    url: "/organ/getOrgansList",
    method: 'post',
    data: query
  })
}
// 添加机构
export const addOrgan = (query) => {
  return service({
    url: "/organ/insOrgan",
    method: 'post',
    data: query
  })
}
// 修改机构
export const editOrgans = (query) => {
  return service({
    url: "/organ/updOrgan",
    method: 'post',
    data: query
  })
}
// 删除机构
export const delOrgan = (query) => {
  return service({
    url: "/organ/delOrgan",
    method: 'post',
    data: query
  })
}
// 获取新闻列表 -只查询type=1 只差标题、id、简介 2查全部
export const getNewsList = (query) => {
  return service({
    url: "/news/findNewsList",
    method: 'post',
    data: query
  })
}
// 添加新闻
export const addNews = (query) => {
  return service({
    url: "/news/add",
    method: 'post',
    data: query
  })
}
// 修改新闻
export const updateNews = (query) => {
  return service({
    url: "/news/changeNews",
    method: 'post',
    data: query
  })
}
// 删除新闻
export const delNews = (id) => {
  return service({
    url: `news/deleteNews/${id}`,
    method: 'post',
  })
}
// 获取某一新闻
export const findNewDetail = (query) => {
  return service({
    url: "/news/findNewsInfoById",
    method: 'post',
    data: query
  })
}